import { render, staticRenderFns } from "./AbkOfferDescriptionForm.vue?vue&type=template&id=d0587a7a&scoped=true&"
import script from "./AbkOfferDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./AbkOfferDescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkOfferDescriptionForm.vue?vue&type=style&index=0&id=d0587a7a&lang=scss&scoped=true&"
import style1 from "./AbkOfferDescriptionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0587a7a",
  null
  
)

export default component.exports